import CloudWatchLogger from './loggers/cloudWachLogger';
import consoleLogger from './loggers/consoleLogger';

const log = {
    trace: (msg, deviceId) => {
        const cloudWatchLogger = new CloudWatchLogger();

        consoleLogger.trace(msg);
        cloudWatchLogger.trace(msg, deviceId);
    },
    debug: (msg, deviceId) => {
        const cloudWatchLogger = new CloudWatchLogger();

        consoleLogger.debug(msg);
        cloudWatchLogger.debug(msg, deviceId);
    },
    info: (msg, deviceId) => {
        const cloudWatchLogger = new CloudWatchLogger();

        consoleLogger.info(msg);
        cloudWatchLogger.info(msg, deviceId);
    },
    warn: (msg, error, deviceId) => {
        const cloudWatchLogger = new CloudWatchLogger();

        consoleLogger.warn(msg, error);
        cloudWatchLogger.warn(msg, error, deviceId);
    },
    error: (msg, error, deviceId) => {
        const cloudWatchLogger = new CloudWatchLogger();

        consoleLogger.error(msg, error);
        cloudWatchLogger.error(msg, error, deviceId);
    },
    fatal: (msg, error, deviceId) => {
        const cloudWatchLogger = new CloudWatchLogger();

        consoleLogger.fatal(msg, error);
        cloudWatchLogger.fatal(msg, error, deviceId);
    },
    resetLogger: () => {
        const cloudWatchLogger = new CloudWatchLogger();

        cloudWatchLogger.resetLogger();
    },
    log: (level, message, error, deviceId) => {
        const cloudWatchLogger = new CloudWatchLogger();

        consoleLogger.log(level, message, error);
        cloudWatchLogger.log({level, message, error, deviceId});
    },
};

export default log;
